import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Skeleton,
} from "@postcheesy/ui-lib/molecules";
import React from "react";
import { Container } from "../../components/layouts/container";
import { Layout } from "../../components/layouts/layout";
import { FormRegister } from "../../components/sections/forms/register";
import { Navigate } from "react-router-dom";
import { useUser } from "../../resources/contexts/UserContext";
import { ROUTES } from "../../resources/constants/routes";

export const RegisterPage: React.FC = () => {
  const { user, loading } = useUser();

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <Skeleton className="w-16 h-16 rounded-full" />
        <p className="mt-2 text-gray-500">Chargement...</p>
      </div>
    );
  }

  if (user) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return (
    <Layout>
      <Container className="py-6">
        <div className="relative mx-auto grid h-full w-fit grid-cols-1 items-start justify-center">
          <section className="lg:my-18 container mx-auto my-12 h-fit max-w-xl py-8 md:my-12 2xl:my-32">
            <Card className="w-full">
              <CardHeader>
                <CardTitle className="text-2xl">{"Créer un compte"}</CardTitle>
                <CardDescription className="w-fit text-pretty">
                  Entrez vos informations ci-dessous pour créer un compte.
                </CardDescription>
              </CardHeader>
              <CardContent>
                <FormRegister />
              </CardContent>
            </Card>
          </section>
        </div>
      </Container>
    </Layout>
  );
};
